<mat-card class="cardWithShadow">
  <mat-card-content>
    <div class="justify-content-center align-items-center d-flex" *ngIf="loading">
      <mat-spinner></mat-spinner>
    </div>
    <div class="table-responsive" id="full-table">
      <table mat-table [dataSource]="contactDetails" matSort class="w-100" *ngIf="!loading">
        <!-- Contact Type -->
        <ng-container matColumnDef="contactType">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">{{ 'Contact.Type.Name' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <div class="d-flex align-items-center">
              <div class="m-l-16">
                <p class="f-w-600 f-s-16 m-b-4 m-t-0">
                  {{ langCode === 'ar' ? element.contactType?.nameAr : element.contactType.nameEn}}

                </p>
              </div>
            </div>
          </td>
        </ng-container>

        <!-- Contact Value -->
        <ng-container matColumnDef="contactValue">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">{{ 'Contact.Detail.Value' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <div class="d-flex align-items-center">
              <div class="m-l-16">
                <p class="f-w-600 f-s-16 m-b-4 m-t-0">
                  {{ element.contactValue }}
                </p>
              </div>
            </div>
          </td>
        </ng-container>

        <!-- Order No -->
        <ng-container matColumnDef="orderNumber">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">{{ 'Contact.Detail.OrderNo' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <div class="d-flex align-items-center">
              <div class="m-l-16">
                <p class="f-w-600 f-s-16 m-b-4 m-t-0">
                  {{ element.orderNo }}
                </p>
              </div>
            </div>
          </td>
        </ng-container>

        <!-- Status -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">{{ 'Shared.Status' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <div class="d-flex align-items-center">
              <div class="m-l-16">
                <p class="f-w-550 f-s-14 m-b-4 m-t-0">
                  <span *ngIf="element.isActive"
                    class="bg-light-success border-success f-s-12 f-w-600 p-6 p-y-4 rounded text-success">
                    {{ 'Shared.Active' | translate }}
                  </span>
                  <span *ngIf="!element.isActive"
                    class="bg-light-error border-error f-s-12 f-w-600 p-6 p-y-4 rounded text-error">
                    {{ 'Shared.Inactive' | translate }}
                  </span>
                </p>
              </div>
            </div>
          </td>
        </ng-container>

        <!-- Action -->
        <ng-container matColumnDef="action" stickyEnd >
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600" class="no-print">{{ 'Shared.Action' | translate
            }}</th>
          <td mat-cell *matCellDef="let element" class="action-link" class="no-print">
            <a (click)="onupdate('Update', element)" class="m-r-10 cursor-pointer"
              matTooltip="{{ 'Shared.Edit' | translate }}"
              *appHasPermission="[lookupPermissions.Sys_Lookup , lookupPermissions.Contact_Management ,lookupPermissions.Sys_ContactDetailScreen ,lookupPermissions.Sys_ContactDetailUpdate]">
              <i-tabler name="edit" class="icon-18"></i-tabler>
            </a>
            <ng-container
              *appHasPermission="[lookupPermissions.Sys_Lookup , lookupPermissions.Contact_Management ,lookupPermissions.Sys_ContactDetailScreen, lookupPermissions.Sys_ContactDetailUpdateStatus]">
              <a (click)="openDialog('Delete', element)" class="m-r-10 cursor-pointer"
                matTooltip="{{ 'Shared.Deactivate' | translate }}" *ngIf="element.isActive">
                <i-tabler name="trash" class="icon-18"></i-tabler>
              </a>
            </ng-container>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <mat-paginator class="no-print" [length]="contactDetails.data.length" [pageSize]="50"
        [pageSizeOptions]="[5, 10, 25, 50]" showFirstLastButtons>
      </mat-paginator>
    </div>
  </mat-card-content>
</mat-card>